module.exports = __webpack_public_path__ + "img/11.cc0f78f4.png";